import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`SMALLHOLDER FARMERS`}</h2>
    <p>{`Worldwide, there are more than 500 million smallholder farmers. They are the ones producing most food, but the majority of them live in poverty. Many have difficulty selling their crops at a fair price and are increasingly faced with the impact of climate change.`}</p>
    <p>{`WFP’s smallholder programmes help farmers diversify their crops and connect them to markets, increasing their business potential and income. These projects compliment established support such as food assistance, training, land rehabilitation and community asset creation.`}</p>
    <p>{`Since 2018, WFP has supported 4,500 female smallholder farmers in `}<strong parentName="p">{`Nicaragua`}</strong>{` with trainings in post-harvest management of crops, budgeting and marketing thanks to funding from the EU. The assistance, which in 2019 was focused on the empowerment of women, allowed them to produce and earn more, helping them become more resilient to economic shocks.`}</p>
    <p>{`In the `}<strong parentName="p">{`Republic of Congo`}</strong>{`, WFP helped smallholder farmers grow beans thanks to funding from the EU. WFP provided them with the seeds, training on new agricultural practices and access to markets – this comprehensive approach allowed farmers to effectively grow and sell crops. The beans also got distributed to local schools where they were cooked and served to children as a nutritious meal.`}</p>
    <p>{`EU funding also enabled WFP to support smallholder farmers in the `}<strong parentName="p">{`Central African Republic`}</strong>{` through its Smallholder Agriculture Market Support (SAMS) activities. By purchasing food commodities from farmers participating in this initiative, WFP allowed them to sell their produce while also stimulating the local economy. This project promoted entrepreneurship among farmers and helped increase their income, which in turn contributed to their long-term resilience.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      